import React from "react";

interface CertificateCardProps {
  skillName: string | undefined;
  date: string | undefined;
  imagUrl: string | undefined;
  onClick?: () => void;
}

const CertificateCard = ({
  skillName,
  date,
  imagUrl,
  onClick,
}: CertificateCardProps) => {
  return (
    <div
      className="dark:border-[rgba(56, 167, 180, 0.2)] flex cursor-pointer flex-col items-start justify-start gap-y-1 rounded-br-[20px] rounded-tl-[20px] border border-navy-blue px-4 py-3 dark:bg-black/15"
      onClick={onClick}
    >
      <img src={imagUrl} alt="no certificate" width={250} height={111} />
      <div className="flex w-full flex-col items-center justify-center gap-y-2 p-3">
        <div className="text-[20px] font-medium dark:text-white">
          {skillName}
        </div>
        <div className="text-[13px] text-[#91959C]">{date}</div>
      </div>
    </div>
  );
};

export default CertificateCard;
